import React from "react";
import { withTranslation } from "react-i18next";
import ReactPlayer from "react-player";
import { withStyles } from "@material-ui/core/styles";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import Checkbox from "@material-ui/core/Checkbox";
import FormGroup from "@material-ui/core/FormGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import TextField from "@material-ui/core/TextField";
import Grid from "@material-ui/core/Grid";
import Select from "@material-ui/core/Select";
import LockOpenIcon from "@material-ui/icons/LockOpen";
import { connect } from "react-redux";
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import LocalHospitalIcon from '@material-ui/icons/LocalHospital';

const useStyles = (theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
    width: "-webkit-fill-available",
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
    backgroundColor: "rgba(0, 0, 0, .02)",
  },
});

let dependantquestionArr = [];

class Questionnaire extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      questionlist: [],
      dependantquestionlist: [],
      dependantquestionArr: [],
      isLoading: false,
      showSlider: true,
      temp: false,
      isPlay: false,
      animCssClasses: "animate__animated animate__zoomIn animate__faster",
    };


  }

  componentDidMount() { }

  static getDerivedStateFromProps(nextProps) {
    return {
      animCssClasses: nextProps.animCssClasses,
      showSlider: nextProps.showSlider,
    };
  }

  callsameCompomnet = () => {
    const { classes } = this.props;
    var element = this.props.question;
    if (element.dependentQuestionResponse != null && element.dependentQuestionResponse.length > 0) {
      return element.dependentQuestionResponse.map((Obj, index) => {
        return (
          <Questionnaire
            key={index}
            question={Obj}
            classes={classes}
            componentbgcolor={this.props.componentbgcolor}
          />
        );
      });
    }
    //return null;
  };

  renderimg(imgs){
    console.log("img",imgs)
    const images=imgs.map((imgsrc)=>{
      return <img
      src={imgsrc}
      width={"100%"}
      light={true}
      style={{ marginTop: "0px" }}
    />;
    });
    return <div>{images}</div>;
  }

  renderQuestion() {
    const { classes } = this.props;
    var element = this.props.question;
    const { templateID } = this.props;
    var compcolor  =  localStorage.getItem('componentbgcolor')
    let colorStyles = templateID == 2 ? { color: compcolor } : {};
    let bgStyles = templateID == 2 ? { background: compcolor } : {};
    var quslist = [];
    return (
      <>
        {
          templateID == 1 ? (
            <Card className="infocard">
              <CardContent className="pt-0px pb-0px">
                <Grid container spacing={3} className="gridcontainer border-bottom-grey">
                  <Grid item xs={2} className="text-center hospitaliconholder color-purple">
                    <LocalHospitalIcon />
                  </Grid>
                  <Grid item xs={10} className="text-left">
                    <p className="hospitalinfo">{element.question}</p>
                  </Grid>
                </Grid>
                <Grid container spacing={3} className="gridcontainer">

                  <Grid item xs={12} className="text-left reportdetailedtextholder">
                    <div className="reportformservice">
                      <FormControl component="fieldset" className={classes.formControl}>
                        <FormGroup>{this.getQuestionType(element)}</FormGroup>
                      </FormControl>
                      {
                        this.callsameCompomnet()
                      }
                    </div>
                  </Grid>
                </Grid>
                <Grid container spacing={3} className="gridcontainer border-top-grey">
                  <Grid item xs={12} className="text-left color-purple">
                    {element && element.responseExtension && element.responseExtension.imageURLs && element.responseExtension.imageURLs.length > 0 &&
                      this.renderimg(element.responseExtension.imageURLs) 
                    }
                    {
                      element && element.responseExtension && element.responseExtension.videoURLs && element.responseExtension.videoURLs.length > 0 &&
                      element.responseExtension.videoURLs.map((video)=>{
                        return(
                        <ReactPlayer
                          url={video}
                          width={"100%"}
                          height={200}
  
                          style={{ marginTop: "0px" }}
                          playing={this.state.isPlay}
                          onPlay={() => this.onPlay()}
                          onPause={() => this.onPause()}
                          controls={true}
                        />)
                      })                  
                    }
                    {
                      element && element.responseExtension && element.responseExtension.audioURLs && element.responseExtension.audioURLs.length > 0 &&
                      element.responseExtension.audioURLs.map((audio)=>{
                        return(
                        <audio className="audiodisplay"
                        controls
                        src={audio}>
                            Your browser does not support the
                            <code>audio</code> element.
                    </audio>)
                      })
                    }
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          ) :
            (
              <>
                <Grid
                  key={element.id}
                  container
                  spacing={0}
                  className="gridcontainer chatuserlistdiv"
                >
                  <Grid item xs={2} className="zero">
                    <p className="zero  text-center forumicon">
                      <LockOpenIcon style={bgStyles} />
                    </p>
                  </Grid>
                  <Grid item xs={10} className="zero">
                    <p className="zero  chatusername" style={colorStyles}>{element.question}</p>
                  </Grid>
                </Grid>
                <div className={classes.root}>
                  <div className="reportformservice">
                    <FormControl component="fieldset" className={classes.formControl}>
                      <FormGroup>{this.getQuestionType(element)}</FormGroup>
                      {
                        this.callsameCompomnet()
                      }
                    </FormControl>
                  </div>
                </div>
                <div className="evidancePreview">
                  {element && element.responseExtension && element.responseExtension.imageURLs && element.responseExtension.imageURLs.length > 0 &&
                  this.renderimg(element.responseExtension.imageURLs)  
                  }
                  {
                      element && element.responseExtension && element.responseExtension.videoURLs && element.responseExtension.videoURLs.length > 0 &&
                      element.responseExtension.videoURLs.map((video)=>{
                        return(
                        <ReactPlayer
                          url={video}
                          width={"100%"}
                          height={200}
  
                          style={{ marginTop: "0px" }}
                          playing={this.state.isPlay}
                          onPlay={() => this.onPlay()}
                          onPause={() => this.onPause()}
                          controls={true}
                        />)
                      })                  
                    }
                    {
                      element && element.responseExtension && element.responseExtension.audioURLs && element.responseExtension.audioURLs.length > 0 &&
                      element.responseExtension.audioURLs.map((audio)=>{
                        return(
                        <audio className="audiodisplay"
                        controls
                        src={audio}>
                            Your browser does not support the
                            <code>audio</code> element.
                    </audio>)
                      })
                    }
                </div>
              </>
            )
        }
      </>
    );
  }


  onPlay() {
    this.setState({ isPlay: true })
  }

  onPause() {
    this.setState({ isPlay: false })
  }



  getQuestionType(element) {
    switch (element.type.toLowerCase()) {
      case "text":
        return this.getTextType(element);
      case "number":
        return this.getTextType(element);
      case "date":
        return this.getDateType(element);
      case "radio":
        return this.getRadioType(element);
      case "checkbox":
        return this.getCheckboxType(element);
      case "dropdown":
        return this.getDropDownType(element);
      default:
        return this.getTextType(element);
    }
  }



  getTextType(element) {
    let val = element["response"]["value"][0]
    let name = element.question.toLowerCase()
    let type = name == 'age' ? 'number' : (name == 'phone number (optional)' ? 'number' : 'text')
    return (
      <FormControlLabel
        className="getinvolvedtextboxholder"
        name={"text-" + element.id}
        value={val}
        
        control={
          <TextField disabled value={val} name={'text-' + element.id} multiline={type=='text'?true:false}
          rows={4} />
        }
      />
    );
  }

  getDateType(element) {
    let val = element["response"]["value"][0]
    return (
      <FormControlLabel
        className="getinvolvedtextboxholder"
        name={"text-" + element.id}
        value={val}
        control={
          <TextField disabled value={val} type="date" name={'date-' + element.id} />
        }
      />
    );
  }

  getDropDownType(element) {
    let options = Object.keys(element.optionMap);
    let val = element["response"]["value"][0]
    return (
      <Select
        labelId="demo-simple-select-label"
        id="demo-simple-select"
        value={val}
        name={element.id}
      >
        {
          options.map((o, i) => {
            return <MenuItem value={o}>{element.optionMap[o]}</MenuItem>
          })
        }
      </Select>
    )
  }

  getRadioType(element) {
    var radiobuttons = [];
    let options = Object.keys(element.optionMap);
    options.map((o, i) => {
      radiobuttons.push(
        <FormControlLabel
          key={i}
          id={i}
          name={"radio-" + element.id}
          value={o}
          control={<Radio name={"radio-" + element.id} />}
          label={element.optionMap[o]}

        />
      );
    });

    let val = element["response"]["value"][0]

    return <RadioGroup name={element.name} value={val}>{radiobuttons}</RadioGroup>;
  }

  getCheckboxType(element) {
    var checkbuttons = [];
    let keys = Object.keys(element.optionMap);
    let response = element["response"]["value"]
    keys.map((o, i) => {
      checkbuttons.push(
        <FormControlLabel
          key={i}
          name={"check-" + element.id}
          checked={response.includes(o)}
          value={o}
          control={<Checkbox name={"checkbox-" + element.id} />}
          label={element.optionMap[o]}

        />
      );
    });
    return <FormGroup>{checkbuttons}</FormGroup>;
  }


  getDepenedantquestion(element) {
    const { classes } = this.props;
    const { templateID } = this.props;
    let colorStyles = templateID == 2 ? { color: this.props.componentbgcolor } : {};
    let bgStyles = templateID == 2 ? { background: this.props.componentbgcolor } : {};
    var quslist = [];
    return (
      <>
        <Grid
          key={element.id}
          container
          spacing={0}
          className="gridcontainer chatuserlistdiv"
        >
          <Grid item xs={2} className="zero">
            <p className="zero  text-center forumicon">
              <LockOpenIcon style={bgStyles} />
            </p>
          </Grid>
          <Grid item xs={10} className="zero">
            <p className="zero  chatusername" style={colorStyles}>{element.question}</p>
          </Grid>
        </Grid>
        <div className={classes.root}>
          <div className="reportform">
            <FormControl component="fieldset" className={classes.formControl}>
              <FormGroup>{this.getQuestionType(element)}</FormGroup>
            </FormControl>
          </div>
        </div>
      </>
    );
  }

  render() {
    const { classes } = this.props;
    const { t } = this.props;

    if (this.props.question) {
      return <>{this.renderQuestion()}</>;
    }
    return null;
  }
}


const mapStateToProps = (state) => {
  let { storeState } = state;
  return {
    templateID: JSON.parse(localStorage.getItem('templateID')) != null ? JSON.parse(localStorage.getItem('templateID')) : storeState.templateID,
    communityuid: storeState.communityId,
    langId: storeState.langId,
    componentbgcolor: storeState.componentbgcolor
  };
};

let newQuestionnaire = withStyles(useStyles)(withTranslation()(Questionnaire));
export default connect(mapStateToProps, {})(newQuestionnaire);
